import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components';
import { carrierActions } from 'store';
import { FindLoad } from 'utils';

const ACTION_TYPE = 'GET_CARRIER_GO_HIGHWAY_DETAILS';

export const GoHighwayInfo = ({ carrierId }) => {
  const { goHighwayDetails } = useSelector((state) => ({
      goHighwayDetails: state.carriers.goHighwayDetails,
    }),
  );
  const dispatch = useDispatch();
  const loading = FindLoad(ACTION_TYPE);


  useEffect(() => {
    if (carrierId) {
      dispatch(carrierActions.getCarriersGoHighWayDetails(carrierId));
    }
  }, [carrierId]);

  // Helper function to format keys
  const formatKey = (key) => {
    return key.split('_').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1),
    ).join(' ');
  };

  // Helper function to format values
  const formatValue = (value, key = '') => {
    if (value === null || value === undefined) return 'N/A';

    if (typeof value === 'boolean') {
      // Special cases for certain boolean fields
      if (key.includes('is_') || key.includes('has_')) {
        return value ? 'YES' : 'NO';
      }
      return value ? 'ON' : 'OFF';
    }

    if (Array.isArray(value)) {
      return value.length === 0 ? 'None' : '';
    }

    if (typeof value === 'object') {
      return '';
    }

    return value.toString();
  };

  // Recursive function to render nested objects
  const renderObject = (obj, parentKey = '') => {
    return Object.entries(obj).map(([key, value]) => {
      const formattedKey = formatKey(key);
      const formattedValue = formatValue(value, key);

      if (value === null || value === undefined) {
        return null;
      }

      if (Array.isArray(value) && value.length === 0) {
        return (
          <div key={`${parentKey}-${key}`} className='data-row'>
            <span className='data-key'>{formattedKey}:</span>
            <span className='data-value'>None</span>
          </div>
        );
      }

      if (typeof value === 'object' && !Array.isArray(value)) {
        return (
          <div key={`${parentKey}-${key}`} className='data-section'>
            <h3 className='section-title'>{formattedKey}</h3>
            <div className='section-content'>
              {renderObject(value, key)}
            </div>
          </div>
        );
      }

      if (Array.isArray(value)) {
        return (
          <div key={`${parentKey}-${key}`} className='data-section'>
            <h3 className='section-title'>{formattedKey}</h3>
            <div className='section-content'>
              {value.map((item, index) => (
                <div key={`${parentKey}-${key}-${index}`} className='array-item'>
                  {typeof item === 'object' ? renderObject(item, `${key}-${index}`) : formatValue(item)}
                </div>
              ))}
            </div>
          </div>
        );
      }

      return (
        <div key={`${parentKey}-${key}`} className='data-row'>
          <span className='data-key'>{formattedKey}:</span>
          <span className='data-value'>{formattedValue}</span>
        </div>
      );
    });
  };

  return (
    <div className='carrier-profile'>
      <div className='profile-content'>
        {loading?.length ?
          <Loader />
          : goHighwayDetails ?
            renderObject(goHighwayDetails)
            :
            <p style={{ fontSize: '18px', fontWeight: 'bold' }}>No Carrier Data Available</p>
        }
      </div>
    </div>
  );
};

